import { Box, Grid, MenuItem } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import ContentLoader from '../../subcomponents/ContentLoader';
import AdminSettingBool from '../inputs/AdminSettingBool';
import AdminSettingColor from '../inputs/AdminSettingColor';
import AdminSettingImage from '../inputs/AdminSettingImage';
import AdminSettingSelect from '../inputs/AdminSettingSelect';

export default function ThemeSettingsTab() {
    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);
    const { activeThemeSettings, defaultTheme, defaultThemeStatus, departmentThemesStatus } = useSelector((state) => state.settings.theme);
    const { siomSettings } = useSelector((state) => state.settings.siom);
    const { changedThemeSettings } = useSelector((state) => state.admin);

    const availableIcons = [
        'Flag',
        'Face',
        'Cup',
        'Apple',
        'Heart',
        'Star',
        'Thumb',
    ];

    // Set default values
    const [defaultValues, setDefaultValues] = useState();
    const [defaultStatus, setDefaultStatus] = useState();

    useEffect(() => {
        if (siomSettings?.useMultipleDepartments) {
            setDefaultStatus(departmentThemesStatus);

            if (departmentThemesStatus === "success")
                setDefaultValues(activeThemeSettings);
        } else {
            setDefaultStatus(defaultThemeStatus);

            if (defaultThemeStatus === "success")
                setDefaultValues(defaultTheme);
        }
    }, [defaultThemeStatus, departmentThemesStatus, changedThemeSettings]);

    return (
        <ContentLoader
            successCondition={defaultStatus === "success"}
            errorCondition={defaultStatus === "failed"}
            content={
                <Box sx={{ width: 1 }}>
                    <Grid container spacing={1} direction="row">
                        <AdminSettingColor
                            settingsType={"theme"}
                            settingKey={"AppTheme_Primary_Color"}
                            settingDefaultValue={defaultValues?.primaryColor}
                            formLabel={resourceFinal[appLanguage].admin.THEME_PRIMARY_COLOR}
                            formText={resourceFinal[appLanguage].admin.THEME_PRIMARY_COLOR_HTEXT}
                            xsSize={6}
                            departmentSetting
                        />
                        <AdminSettingColor
                            settingsType={"theme"}
                            settingKey={"AppTheme_Secondary_Color"}
                            settingDefaultValue={defaultValues?.secondaryColor}
                            formLabel={resourceFinal[appLanguage].admin.THEME_SECONDARY_COLOR}
                            formText={resourceFinal[appLanguage].admin.THEME_SECONDARY_COLOR_HTEXT}
                            xsSize={6}
                            departmentSetting
                        />
                        <AdminSettingImage
                            settingsType={"theme"}
                            settingKey={"AppTheme_Logo"}
                            formLabel={resourceFinal[appLanguage].admin.THEME_LOGO}
                            formText={resourceFinal[appLanguage].admin.THEME_LOGO_HTEXT}
                            xsSize={6}
                            departmentSetting
                        />
                        <AdminSettingBool
                            settingsType={"theme"}
                            settingKey={"AppTheme_FlagsEnabled"}
                            settingDefaultValue={defaultValues?.flagsEnabled}
                            formLabel={resourceFinal[appLanguage].admin.THEME_FLAGS}
                            formText={resourceFinal[appLanguage].admin.THEME_FLAGS_HTEXT}
                            controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                            xsSize={6}
                            departmentSetting
                        />
                        <AdminSettingBool
                            settingsType={"theme"}
                            settingKey={"AppTheme_HideYellowFlags"}
                            settingDefaultValue={defaultValues?.hideYellowFlags}
                            formLabel={resourceFinal[appLanguage].admin.THEME_YELLOW_FLAGS}
                            formText={resourceFinal[appLanguage].admin.THEME_YELLOW_FLAGS_HTEXT}
                            controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                            disabledCondition={!defaultValues?.flagsEnabled}
                            xsSize={6}
                            departmentSetting
                        />
                        <AdminSettingBool
                            settingsType={"theme"}
                            settingKey={"AppTheme_Show_OrangeFlags"}
                            settingDefaultValue={defaultValues?.showOrangeFlags}
                            formLabel={resourceFinal[appLanguage].admin.THEME_ORANGE_FLAGS}
                            formText={resourceFinal[appLanguage].admin.THEME_ORANGE_FLAGS_HTEXT}
                            controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                            disabledCondition={!defaultValues?.flagsEnabled}
                            xsSize={6}
                            departmentSetting
                        />
                        <AdminSettingSelect
                            settingsType={"theme"}
                            settingKey={"AppTheme_FlagStyle"}
                            settingDefaultValue={defaultValues?.flagStyle}
                            formLabel={resourceFinal[appLanguage].admin.THEME_FLAGS_STYLE}
                            formText={resourceFinal[appLanguage].admin.THEME_FLAGS_STYLE_HTEXT}
                            disabledCondition={!defaultValues?.flagsEnabled}
                            xsSize={6}
                            departmentSetting
                            menuItems={
                                availableIcons.map((item) =>
                                    <MenuItem value={item.toLowerCase()}>{item}</MenuItem>
                                )
                            }
                        />
                        <AdminSettingBool
                            settingsType={"theme"}
                            settingKey={"AppTheme_TjlEnabled"}
                            settingDefaultValue={defaultValues?.tjlEnabled}
                            formLabel={resourceFinal[appLanguage].admin.THEME_TJL}
                            formText={resourceFinal[appLanguage].admin.THEME_TJL_HTEXT}
                            controlLabel={resourceFinal[appLanguage].admin.ADMIN_GENERAL_ON}
                            xsSize={6}
                            departmentSetting
                        />
                        <AdminSettingSelect
                            settingsType={"theme"}
                            settingKey={"AppTheme_TjlStyle"}
                            settingDefaultValue={defaultValues?.tjlStyle}
                            formLabel={resourceFinal[appLanguage].admin.THEME_TJL_STYLE}
                            formText={resourceFinal[appLanguage].admin.THEME_TJL_STYLE_HTEXT}
                            disabledCondition={!defaultValues?.flagsEnabled || !defaultValues?.tjlEnabled}
                            xsSize={6}
                            departmentSetting
                            menuItems={
                                availableIcons.map((item) =>
                                    <MenuItem value={item.toLowerCase()}>{item}</MenuItem>
                                )
                            }
                        />
                        <AdminSettingSelect
                            settingsType={"theme"}
                            settingKey={"AppTheme_RequiredProgramIconStyle"}
                            settingDefaultValue={defaultValues?.requiredProgramIconStyle}
                            formLabel={resourceFinal[appLanguage].admin.THEME_REQ_PROGRAM_ICON}
                            formText={resourceFinal[appLanguage].admin.THEME_REQ_PROGRAM_ICON_HTEXT}
                            disabledCondition={!siomSettings?.enableRequiredPrograms}
                            xsSize={6}
                            departmentSetting
                            menuItems={
                                availableIcons.map((item) =>
                                    <MenuItem value={item.toLowerCase()}>{item}</MenuItem>
                                )
                            }
                        />
                    </Grid>
                </ Box>
            }
        />
    );
}
